import { envConfig } from '../config/vapi.config';

interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

interface ChatApiResponse {
  id: string;
  assistantId: string;
  messages: ChatMessage[];
  output: ChatMessage[];
  createdAt: string;
  updatedAt: string;
  orgId?: string;
  sessionId?: string;
  name?: string;
}

interface ChatResponse {
  chatId: string;
  response: string;
  fullData: ChatApiResponse;
}

export async function sendChatMessage(
  message: string, 
  previousChatId?: string
): Promise<ChatResponse> {
  const response = await fetch('https://api.vapi.ai/chat', {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${envConfig.vapi.api_key}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      assistantId: envConfig.vapi.assistant_id,
      input: message,
      ...(previousChatId && { previousChatId })
    })
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error('API Error:', response.status, errorText);
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const chat: ChatApiResponse = await response.json();
  
  // Validate response structure
  if (!chat || !chat.output || !chat.output[0] || !chat.output[0].content) {
    console.error('Invalid API response structure:', chat);
    throw new Error('Invalid response from chat API');
  }
  
  // Clean the response by removing unwanted text
  let cleanResponse = chat.output[0].content;
  
  // Remove common unwanted phrases
  const unwantedPhrases = [
    '<WAIT FOR USER RESPONSE>',
    'WAIT FOR USER RESPONSE',
    '<wait for user response>',
    'wait for user response'
  ];
  
  unwantedPhrases.forEach(phrase => {
    cleanResponse = cleanResponse.replace(new RegExp(phrase, 'gi'), '').trim();
  });
  
  return {
    chatId: chat.id,
    response: cleanResponse,
    fullData: chat
  };
}
